import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppTokenHandler } from '../../common/app-token-handler';
import { environment } from '../../../environments/environment';

enum Roles {
    Admin,
    Finance,
    Approver,
    NoDue,
    NormalUser  //Added by dhirendra for CR_2502_0025
}
@Component({
    selector: 'app-top-navbar',
    templateUrl: './top-navbar.component.html',
    styleUrls: ['./top-navbar.component.css'],
    standalone: false
})
export class TopNavbarComponent implements OnInit {
    menuitems: MenuItem[];
    useritems: MenuItem[];
    subitems: Array<{ label: string, icon: string, routerLink: string }> = [];
    constructor(private router: Router, private appToken: AppTokenHandler) {
    }
    ngOnInit() {
        this.BindMenuItems();
    }
    CreateNewRequest() {
        this.appToken.setRequestType('');
        this.router.navigate(['/home/new']);
    }
    OpenTab() {
        let _privacyNotice = "assets/ultimate_guide.pdf";
        window.open(_privacyNotice, '_blank');
    }
    BindMenuItems() {
        this.menuitems = [
            {
                label: 'Home', routerLink: '/home/dashboard'
            },
            {
                label: 'MDM Supplier',
                visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Approver]) || this.appToken.IsInRole(Roles[Roles.Finance])),   //  Added by dhirendra for CR_2502_0025
                items: [
                    {
                        label: 'Create MDM Vendor',
                        routerLink: '/vendor/vendormodify/0',
                        // queryParams:{SupplierId:0},
                        //visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Approver]) || this.appToken.IsInRole(Roles[Roles.Finance])) //  Added by dhirendra for CR_2502_0025
                        visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Finance])) //  Added by dhirendra for CR_2502_0025
                    },
                    {
                        label: 'MDM Vendor Request',
                        routerLink: '/vendor/vendorrequest',
                        visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Approver]) || this.appToken.IsInRole(Roles[Roles.Finance]))
                    },
                    {
                        label: 'Vendor Approval', routerLink: '/vendor/vendorapproval',
                        visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Approver]))
                    }
                ],
            },
            {
                label: 'ECC Supplier',
                visible: (this.appToken.IsInRole(Roles[Roles.Approver]) || this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Finance])),    // Normaluser Added by dhirendra for CR_2502_0025
                items: [
                    {
                        label: 'Create ECC Vendor', routerLink: '/vendor/eccvendorsearch',
                        //visible: (this.appToken.IsInRole(Roles[Roles.Approver]) || this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Finance]))
                        visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Finance]))
                    },
                    {
                        label: 'ECC Vendor Request', routerLink: '/vendor/eccvendorlist',
                        visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Approver]))
                    },
                    {
                        label: 'ECC Vendor Approval', routerLink: '/vendor/eccvendorapproval',
                        visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Approver]))
                    }
                ],
            },
            {
                label: 'All Vendor', routerLink: '/vendor/allvendor',
                visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Approver]) || this.appToken.IsInRole(Roles[Roles.Finance]))
            },
            {
                label: 'No Due Certificate',
                visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.NoDue]) || this.appToken.IsInRole(Roles[Roles.Finance]) || this.appToken.IsInRole(Roles[Roles.NormalUser])),   //   Normaluser Added by dhirendra for CR_2502_0025
                items: [
                    {
                        label: 'Maintain No Due Certificate',
                        routerLink: '/vendor/MaintainNdcComponent',
                        visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.NoDue]) || this.appToken.IsInRole(Roles[Roles.Finance]) || this.appToken.IsInRole(Roles[Roles.NormalUser]))   //   Normaluser Added by dhirendra for CR_2502_0025
                    },
                    {
                        label: 'View No Due Certificate',
                        routerLink: '/vendor/ViewMaintainNdcComponent',
                        visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.NoDue]) || this.appToken.IsInRole(Roles[Roles.Finance]) || this.appToken.IsInRole(Roles[Roles.NormalUser]))  //   Normaluser Added by dhirendra for CR_2502_0025

                    }
                ]
            }
            //   {
            //       label: 'Tracking Progress',
            //       items: [
            //           //{ label: 'Create New Request', routerLink: '/home/new' }
            //           { label: 'Create Request', command: () => this.CreateNewRequest() }
            //       ],
            //       visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Counsellor]))
            //   },
            //   {
            //       label: 'Views',
            //       items: [                    
            //           { label: 'View Tracking Requests', routerLink: '/home/trackinglist' }
            //       ],
            //       visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.Counsellor]) || this.appToken.IsInRole(Roles[Roles.SLHR]) || this.appToken.IsInRole(Roles[Roles.CHR]) || this.appToken.IsInRole(Roles[Roles.CFTL]))
            //   },
            //   {
            //       label: 'Reports',
            //       items: [                    
            //           { label: 'Tracking Requests Report', routerLink: '/home/reports' },
            //           { label: 'Tracking Status Summary Report', routerLink: '/home/SummaryReport' }
            //       ],
            //       visible: (this.appToken.IsInRole(Roles[Roles.Admin]) || this.appToken.IsInRole(Roles[Roles.SLHR]) || this.appToken.IsInRole(Roles[Roles.CHR]) || this.appToken.IsInRole(Roles[Roles.CFTL])),

            //   },
            //   {
            //       label: 'Useful Resources',
            //       items: [                    
            //           { label: 'FAQ', command: () => this.OpenTab() },                   
            //       ],

            //   },
            // {
            //     label: 'Masters',
            //     items: [
            //         { label: 'Location Owner Mapping', routerLink: '/home/location' },
            //         { label: 'Location & Floor Mapping', routerLink: '/home/floor' }
            //     ],
            //     visible: (this.appToken.IsInRole(Roles[Roles.Admin]))
            // }
        ];

        if (!environment.production) {
            this.subitems.push({ label: 'Run as different user', icon: 'fa fa-unlock', routerLink: '/dummylogin' });
        }
        this.subitems.push({ label: 'Logout', icon: 'fa fa-sign-out', routerLink: '/logout' });
        this.useritems = [
            {
                label: this.appToken.getLoginUserInfo().EmpName, icon: 'fa fa-user',
                items: this.subitems
            },
        ];

    };
}
